/* 1119 cart drawer: wordmark header, red total band, order-protection switch, auto open.
   Notes for whoever edits this next:
   - Every write is guarded by a comparison, because a MutationObserver drives this file.
   - The observer watches the drawer only. Watching the document made the promo-bar
     countdown, which ticks every second, re-run all of this once a second.
   - The heading rewrite is scoped to .theme-drawer__header: the empty-cart state reuses
     the same class for its own "Your cart is empty" line, which must stay.
   - Any add re-pulls the drawer section before opening, because an add that did not come
     from a theme form leaves the rendered drawer showing the previous cart.
   - Protection can start switched on, but once a shopper switches it off that choice is
     remembered for the visit. Re-adding a charge somebody just removed is not on. */
(function () {
  if (window.__gtcCart) return;
  window.__gtcCart = 1;
  var internal = false;
  var cleaning = false;
  var seeding = false;
  var cache = null;
  var cacheAt = 0;
  var OPT_OUT = 'gtcProtOff';
  function q(s, r) { return (r || document).querySelector(s); }
  function cfg() { var el = document.getElementById('gtap-cart-config'); return el ? el.dataset : {}; }
  function optedOut() { try { return sessionStorage.getItem(OPT_OUT) === '1'; } catch (e) { return false; } }
  function setOptOut(v) { try { v ? sessionStorage.setItem(OPT_OUT, '1') : sessionStorage.removeItem(OPT_OUT); } catch (e) {} }

  function getCart(force) {
    if (!force && cache && Date.now() - cacheAt < 1500) return Promise.resolve(cache);
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      cache = c; cacheAt = Date.now(); return c;
    });
  }

  function refresh() {
    cache = null;
    return fetch('/?sections=cart-drawer-section&_=' + Date.now())
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j['cart-drawer-section'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-hydration-key="cart-drawer-inner"]');
        var cur = document.querySelector('[data-hydration-key="cart-drawer-inner"]');
        if (fresh && cur) cur.replaceWith(fresh);
      })
      .catch(function () {})
      .then(function () { return getCart(true); })
      .then(function (cart) {
        document.querySelectorAll('.cart-bubble__text,[data-cart-count]').forEach(function (n) {
          if (n.textContent.trim() !== String(cart.item_count)) n.textContent = cart.item_count;
        });
      })
      .catch(function () {})
      .then(function () { decorate(); });
  }

  window.GTC = {
    refresh: refresh,
    lock: function (v) { internal = v; },
    decorate: function () { decorate(); }
  };

  function head(root) {
    var h = q('.theme-drawer__header .theme-drawer__title', root);
    if (h) {
      if (!h.querySelector('.gtc-mark')) {
        var m = document.createElement('span');
        m.className = 'gtc-mark';
        m.textContent = '1119';
        h.prepend(m);
      }
      var txt = null;
      h.childNodes.forEach(function (n) { if (n.nodeType === 3 && n.textContent.trim()) txt = n; });
      if (txt) { if (txt.textContent !== ' Your cart ') txt.textContent = ' Your cart '; }
      else h.insertBefore(document.createTextNode(' Your cart '), h.querySelector('.theme-drawer__badge'));
    }
    var lbl = q('.cart-totals__total-label', root);
    if (lbl && lbl.textContent.trim() !== 'Total:') lbl.textContent = 'Total:';
    var bt = q('.cart__checkout-button .button-text', root);
    if (bt && bt.textContent.trim() !== 'Checkout') bt.textContent = 'Checkout';
    var ctas = q('.cart__ctas', root);
    if (ctas && !ctas.querySelector('.gtc-ship')) {
      var s = document.createElement('span');
      s.className = 'gtc-ship';
      s.textContent = cfg().shippingNote || 'Shipping calculated at checkout';
      ctas.appendChild(s);
    }
  }

  function addLine(vid) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
    });
  }
  function dropLine(cart, vid) {
    var idx = -1;
    cart.items.forEach(function (i, n) { if (String(i.variant_id) === String(vid)) idx = n; });
    if (idx < 0) return Promise.resolve(null);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: idx + 1, quantity: 0 })
    });
  }

  function prot(root) {
    var c = cfg();
    var vid = c.protectionVariant;
    var sum = q('.cart-drawer__summary', root);
    if (!vid || !sum) return;
    var row = sum.querySelector('.gtc-prot');
    if (!row) {
      row = document.createElement('div');
      row.className = 'gtc-prot';
      row.innerHTML = '<span class="gtc-prot__label"></span><span class="gtc-prot__i">i</span><span class="gtc-prot__price"></span><button class="gtc-prot__sw" type="button" aria-pressed="false"></button>';
      row.querySelector('.gtc-prot__label').textContent = c.protectionLabel || 'Protect your order';
      row.querySelector('.gtc-prot__i').title = c.protectionInfo || '';
      row.querySelector('.gtc-prot__price').textContent = c.protectionPrice || '';
      var sw = row.querySelector('.gtc-prot__sw');
      sw.setAttribute('aria-label', c.protectionLabel || 'Protect your order');
      sw.addEventListener('click', function () { toggle(row, vid); });
      sum.prepend(row);
    }
    getCart().then(function (cart) {
      var on = cart.items.some(function (i) { return String(i.variant_id) === String(vid); });
      var others = cart.items.filter(function (i) { return String(i.variant_id) !== String(vid); }).length;
      var sw2 = row.querySelector('.gtc-prot__sw');
      if (sw2.getAttribute('aria-pressed') !== String(on)) sw2.setAttribute('aria-pressed', String(on));
      if (row.hidden !== (others === 0)) row.hidden = others === 0;

      /* protection on its own is not a basket, so drop it when the last garment leaves */
      if (on && others === 0 && !cleaning) {
        cleaning = true;
        internal = true;
        dropLine(cart, vid).then(function () { return refresh(); }).catch(function () {}).then(function () {
          internal = false;
          cleaning = false;
        });
        return;
      }
      /* switched on by default, unless this visitor already turned it off */
      if (!on && others > 0 && c.protectionDefault === '1' && !optedOut() && !seeding) {
        seeding = true;
        internal = true;
        addLine(vid).then(function () { return refresh(); }).catch(function () {}).then(function () {
          internal = false;
          seeding = false;
        });
      }
    }).catch(function () {});
  }

  function toggle(row, vid) {
    var sw = row.querySelector('.gtc-prot__sw');
    var on = sw.getAttribute('aria-pressed') === 'true';
    row.dataset.busy = '1';
    internal = true;
    setOptOut(on);
    var step = on
      ? getCart(true).then(function (cart) { return dropLine(cart, vid); })
      : addLine(vid);
    step.then(function () { return refresh(); }).catch(function () {}).then(function () {
      internal = false;
      delete row.dataset.busy;
    });
  }

  function decorate() {
    var root = document.getElementById('cart-drawer');
    if (!root) return;
    head(root);
    prot(root);
    document.dispatchEvent(new CustomEvent('gtc:decorate'));
  }

  var of = window.fetch;
  window.fetch = function () {
    var a = arguments;
    var u = typeof a[0] === 'string' ? a[0] : (a[0] && a[0].url) || '';
    var p = of.apply(this, a);
    if (u.indexOf('/cart/') > -1 && u.indexOf('/cart.js') < 0) cache = null;
    if (u.indexOf('/cart/add') > -1) {
      p.then(function (r) {
        if (!r.ok || internal) return;
        setTimeout(function () {
          refresh().then(function () {
            var d = document.getElementById('cart-drawer');
            if (d && typeof d.open === 'function') d.open();
          });
        }, 400);
      }).catch(function () {});
    }
    return p;
  };

  var t;
  function watch() {
    var target = document.getElementById('cart-drawer');
    if (!target) return false;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(decorate, 80); })
      .observe(target, { childList: true, subtree: true });
    return true;
  }
  function boot() { decorate(); if (!watch()) setTimeout(boot, 400); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
